import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_useIsMobile_mjs_3e33de32__ from "../hooks/useIsMobile.mjs";
function EmptyState({ icon, title, description, primaryActionLabel, primaryActionOnClick, primaryActionVariant = "default", secondaryActionLabel, secondaryActionOnClick, secondaryActionVariant = "outline", learnMoreHref, learnMoreLabel, horizontal = false, children }) {
    const isMobile = (0, __WEBPACK_EXTERNAL_MODULE__hooks_useIsMobile_mjs_3e33de32__.useIsMobile)();
    if (horizontal && !isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "tw-flex tw-items-center tw-justify-between tw-w-full tw-p-8",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-flex-1",
                children: [
                    title && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h3", {
                        className: "tw-mb-2 tw-text-lg tw-font-semibold",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                        className: "tw-mb-6 tw-text-sm tw-text-muted-foreground tw-max-w-sm",
                        children: description
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-space-x-3",
                        children: [
                            primaryActionLabel && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: primaryActionVariant,
                                size: "sm",
                                onClick: primaryActionOnClick,
                                children: primaryActionLabel
                            }),
                            secondaryActionLabel && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: secondaryActionVariant,
                                size: "sm",
                                onClick: secondaryActionOnClick,
                                children: secondaryActionLabel
                            }),
                            children,
                            learnMoreHref && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("a", {
                                href: learnMoreHref,
                                className: "tw-text-sm tw-text-muted-foreground hover:tw-underline tw-inline-flex tw-items-center",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    learnMoreLabel,
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ExternalLink, {
                                        className: "tw-ml-1 tw-h-3 tw-w-3"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            icon && icon
        ]
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8",
        children: [
            icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "tw-mb-4",
                children: icon
            }),
            title && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h3", {
                className: "tw-mb-2 tw-text-lg tw-font-semibold",
                children: title
            }),
            description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                className: "tw-mb-6 tw-text-sm tw-text-muted-foreground tw-text-center tw-max-w-sm",
                children: description
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center tw-space-y-4",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "tw-flex tw-flex-row tw-space-x-4",
                        children: [
                            secondaryActionLabel && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: secondaryActionVariant,
                                size: "sm",
                                onClick: secondaryActionOnClick,
                                children: secondaryActionLabel
                            }),
                            primaryActionLabel && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: primaryActionVariant,
                                size: "sm",
                                onClick: primaryActionOnClick,
                                children: primaryActionLabel
                            }),
                            children
                        ]
                    }),
                    learnMoreHref && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("a", {
                        href: learnMoreHref,
                        className: "tw-text-sm tw-text-muted-foreground hover:tw-underline tw-inline-flex tw-items-center",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            learnMoreLabel,
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ExternalLink, {
                                className: "tw-ml-1 tw-h-3 tw-w-3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export { EmptyState };

//# sourceMappingURL=empty-state.mjs.map